import { createFileRoute } from '@tanstack/react-router';
import { WorkbenchBoardPage } from '@/features/locations/WorkbenchBoardPage';
import { validateLocationSearch } from '@/features/locations/search';

export const Route = createFileRoute('/app/board/')({
  validateSearch: validateLocationSearch,
  component: BoardRoute,
  staticData: { title: 'Board' },
});

function BoardRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <WorkbenchBoardPage search={search} onSearchChange={(next, push) => void navigate({ search: next, replace: !push, resetScroll: false })} />;
}
